import type { ProfileResponse } from "@circle-react/hooks/profile/useProfileInfo";
import { noop } from "lodash";
import type { ReactNode } from "react";
import { createContext, useContext } from "react";

export type ProfileContextMember = ProfileResponse;

interface ProfileContextValue {
  isFullPageView?: boolean;
  isLoading: boolean;
  member?: ProfileContextMember;
  onClose?: () => void;
  refetchProfileInfo?: () => void;
}

const ProfileContext = createContext<ProfileContextValue>({
  isFullPageView: false,
  isLoading: false,
  onClose: noop,
  refetchProfileInfo: noop,
});

ProfileContext.displayName = "ProfileContext";

export const useProfileContext = () => useContext(ProfileContext);

interface ProfileContextProviderProps {
  children: ReactNode;
  isFullPageView?: boolean;
  isLoading: boolean;
  member: ProfileResponse | undefined;
  onClose?: () => void;
  refetchProfileInfo?: () => void;
}

export const ProfileContextProvider = ({
  member,
  isFullPageView = false,
  isLoading,
  children,
  onClose = noop,
  refetchProfileInfo,
}: ProfileContextProviderProps) => (
  <ProfileContext.Provider
    value={{
      isFullPageView,
      isLoading,
      member,
      onClose,
      refetchProfileInfo,
    }}
  >
    {children}
  </ProfileContext.Provider>
);
